import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
const SalarySlips = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            <div class="row mx-0 payroll-page">
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <h4 class="event-alert">Salary Slip Generator</h4>
                    <div class="row justify-content-between">
                      <div class="col-4 search-box d-flex">
                        <label className="label">
                          <strong>Payroll Period</strong>{" "}
                        </label>
                        <div class="select-div col-md-6 col">
                          <select class="select w-100">
                            <option>Select Payroll Period</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="checklist-table remove-space inventory_table">
                        <thead>
                          <tr>
                            <th className="col">
                              <a class="checkbox avaiCheck">
                                <input
                                  type="checkbox"
                                  name="master_check"
                                  class="avail_checkbox"
                                  value=""
                                  id="checkbox_menu_id"
                                />
                                <label for="checkbox_menu_id"></label>
                              </a>
                            </th>
                            <th className="col-12"> Name </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <a class="checkbox avaiCheck">
                                <input
                                  type="checkbox"
                                  name="ids[]"
                                  class="avail_checkbox child_box"
                                  value="15558"
                                  id="order_id_15558"
                                />{" "}
                                <label for="order_id_15558"> </label>
                              </a>
                            </td>
                            <td> Cynthia </td>
                          </tr>
                          <tr>
                            <td>
                              <a class="checkbox avaiCheck">
                                <input
                                  type="checkbox"
                                  name="ids[]"
                                  class="avail_checkbox child_box"
                                  value="15558"
                                  id="order_id_15558"
                                />{" "}
                                <label for="order_id_15558"> </label>
                              </a>
                            </td>
                            <td> John </td>
                          </tr>
                          <tr>
                            <td>
                              <a class="checkbox avaiCheck">
                                <input
                                  type="checkbox"
                                  name="ids[]"
                                  class="avail_checkbox child_box"
                                  value="15558"
                                  id="order_id_15558"
                                />{" "}
                                <label for="order_id_15558"> </label>
                              </a>
                            </td>
                            <td> Joseph </td>
                          </tr>
                          <tr>
                            <td>
                              <a class="checkbox avaiCheck">
                                <input
                                  type="checkbox"
                                  name="ids[]"
                                  class="avail_checkbox child_box"
                                  value="15558"
                                  id="order_id_15558"
                                />{" "}
                                <label for="order_id_15558"> </label>
                              </a>
                            </td>
                            <td> Mario </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mx-0 px-0">
                <div class="container px-0 d-flex col-12">
                  <div class="btns d-flex justify-content-md-end justify-content-between py-4 col-12">
                    <button id="" type="Submit" className="mx-0">
                      View PDF
                    </button>
                    <button id="" type="Submit" className="mx-sm-3 mx-0">
                      Send Mail
                    </button>
                    <button id="cancel" type="button" className="mx-0">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default SalarySlips;
